import { Action } from 'redux';

import ActionPayloadNumber from '../interfaces/actions/ActionPayloadNumber';
import ActionPayloadString from '../interfaces/actions/ActionPayloadString';
import ActionFetchFindUserSuccess from '../interfaces/actions/ActionFetchFindUserSuccess';
import UserInfoResponse from '../interfaces/UserInfoResponse';

import * as Const from '../constants';

export const fetchFindUserInitAction = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_INIT,
  };
};

export const fetchFindUserPendingAction = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_PENDING,
  };
};

export const fetchFindUserSuccessAction = (payload: UserInfoResponse): ActionFetchFindUserSuccess => {
  return {
    type: Const.FETCH_FIND_USER_SUCCESS,
    payload,
  };
};

export const fetchFindUserFailAction = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_FAIL,
  };
};

export const fetchFindUserAuthIdAction = (payload: string): ActionPayloadString => {
  return {
    type: Const.FETCH_FIND_USER_AUTH_ID,
    payload,
  };
};

export const fetchFindUserEmailAction = (payload: string): ActionPayloadString => {
  return {
    type: Const.FETCH_FIND_USER_EMAIL,
    payload,
  };
};

export const fetchFindUserEnableInputsAction = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_ENABLE_INPUTS,
  };
};

export const fetchActiveTabAction = (payload: number): ActionPayloadNumber => {
  return {
    type: Const.FETCH_FIND_USER_ACTIVE_TAB,
    payload,
  };
};

export const fetchFindUserSearchErrorInit = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_FAIL_WHILE_SEARCH_INIT,
  };
};

export const fetchFindUserDisableId = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_DISABLE_ID,
  };
};

export const fetchFindUserDisableEmail = (): Action => {
  return {
    type: Const.FETCH_FIND_USER_DISABLE_EMAIL,
  };
};
